export const scrollToBottom = (): void => {
    window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth',
    });
};
